import {InitPage} from "../index";
import {ImportFile} from "../common/import_file";

class Customers {
    constructor() {
        const _this = this;

        this.initializeHTML();

        InitPage("customers step_2", () => {
            _this.set_country();
            _this.set_shipping_info();
        });

        $("#customer_copy_billing_to_shipping").on('click',function(){
           _this.set_shipping_info();
            
        });

        $('.editBtn').on('click',function(e){
            e.preventDefault();
            $("#commit i").removeClass('fa-plus-circle');
            $("#commit i").addClass('fa-save');
            const _anchor = this;
            let editPath = $(_anchor).data("edit-path");
            $.ajax({
                url: editPath,
                method: "get",
            }).then(response => {
                $("#customer_location_id").val(response.id);
                $("#customer_location_name").val(response.name);
                $("#customer_location_phone").val(response.phone);
                $("#customer_location_shipping_country").val(response.shipping_country);
                $("#customer_location_shipping_state").val(response.shipping_state);
                $("#customer_location_shipping_city").val(response.shipping_city);
                $("#customer_location_shipping_zip").val(response.shipping_zip);
                $("#customer_location_shipping_address").val(response.shipping_address);
                $("#new_customer_location").attr("action",editPath.replace(/edit/g,""));
                $("#new_customer_location").attr("method",'patch');                
            });
        });

        InitPage("index", () => {
            let import_file = new ImportFile();
        })
    }

    initializeHTML() {
        
    }

    set_shipping_info() {
        let copyStatus = $("#customer_copy_billing_to_shipping").is(":checked");
        let prevAddress1 = $("#customer_shipping_address1").attr('data-value');
        let prevAddress2 = $("#customer_shipping_address2").attr('data-value');
        let prevcity = $("#customer_shipping_city").attr('data-value');
        let prevstate = $("#customer_shipping_state").attr('data-value');
        let prevcountry = $("#customer_shipping_country").attr('data-value');
        let prevzip = $("#customer_shipping_zip").attr('data-value');
        if(copyStatus)
        {
            $("#customer_shipping_address1").val($("#customer_billing_address1").val());
            $("#customer_shipping_address2").val($("#customer_billing_address2").val());
            $("#customer_shipping_city").val($("#customer_billing_city").val());
            $("#customer_shipping_state").val($("#customer_billing_state").val());
            $("#customer_shipping_country").val($("#customer_billing_country").val());
            $("#customer_shipping_zip").val($("#customer_billing_zip").val());
            $(".copy_data").attr("readonly","readonly");
            $(".copy_data").addClass("readonly");
            $("#customer_shipping_country").attr('disabled','disabled');
        }
        else
        {
            //$(".copy_data").val("");
            $("#customer_shipping_address1").val(prevAddress1);
            $("#customer_shipping_address2").val(prevAddress2);
            $("#customer_shipping_city").val(prevcity);
            $("#customer_shipping_state").val(prevstate);
            $("#customer_shipping_country").val(prevcountry);
            $("#customer_shipping_zip").val(prevzip);
            $(".copy_data").removeAttr("readonly");
            $(".copy_data").removeClass("readonly");
            $("#customer_shipping_country").removeAttr('disabled');
        }
    }

    set_country() {
        if($('#customer_billing_country').attr('data-value') != "")
            $('#customer_billing_country').val($('#customer_billing_country').attr('data-value'));
        if($('#customer_shipping_country').attr('data-value') != "")
            $('#customer_shipping_country').val($('#customer_shipping_country').attr('data-value'));
    }
}


export function LoadPage() {
    InitPage("customers", () => {
        const customers = new Customers();
    });
}
